import { useState, useEffect, useRef, useCallback } from "react";
// import { DateRange } from "react-date-range";
// import { format } from 'date-fns';
// import { enUS } from "date-fns/locale";
import axios from 'axios';
import flatpickr from "flatpickr";
import Hearder from "../commun/Hearder";
import SideBar from "../commun/SideBar";
// import { BarChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend, ResponsiveContainer, } from "recharts";
import { DashboRoomInventory, PropertyBookingCancle, Propertybookingpdf, Propertybookings, PropertyCancelReason, PropertyDynamicVoucher } from "../../Services/Service";
import { format, addDays, differenceInDays } from "date-fns";

import swal from "sweetalert";



export const Dashboard = () => {
    const inputRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [bookingData, setBookingData] = useState([]);
    const [cancelCodes, setCancelCodes] = useState([]);
    const [selectedCode, setSelectedCode] = useState("");
    const [cancelReason, setCancelReason] = useState("");
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [selectedDates, setSelectedDates] = useState(() => {
        const today = new Date();
        const days = [];
        for (let i = 0; i < 7; i++) {
            days.push(addDays(today, i));
        }
        return days;
    });
    const [roomData, setRoomData] = useState({}); // grouped data

    //  Fetch API Data
    // useEffect(() => {
    //     const fetchData = async () => {
    //         if (selectedDates.length < 2) return;

    //         const start = format(selectedDates[0], "yyyy-MM-dd");
    //         const end = format(selectedDates[selectedDates.length - 1], "yyyy-MM-dd");

    //         try {
    //             const data = await DashboRoomInventory(start, end);

    //             // Group by RoomTypeCode
    //             const grouped = {};
    //             data.forEach((item) => {
    //                 const dateStr = format(new Date(item.Date), "yyyy-MM-dd");
    //                 if (!grouped[item.RoomTypeCode]) {
    //                     grouped[item.RoomTypeCode] = {};
    //                 }
    //                 grouped[item.RoomTypeCode][dateStr] = item.Count;
    //             });

    //             setRoomData(grouped);
    //         } catch (err) {
    //             console.error("Error fetching inventory:", err);
    //         }
    //     };

    //     fetchData();
    // }, [selectedDates]);

    const fetchInventory = useCallback(async () => {
        if (selectedDates.length < 2) return;

        const start = format(selectedDates[0], "yyyy-MM-dd");
        const end = format(selectedDates[selectedDates.length - 1], "yyyy-MM-dd");

        console.log("Start Date:", start);
        console.log("End Date:", end);

        try {
            setLoading(true);
            const data = await DashboRoomInventory(start, end);

            const grouped = {};
            data.forEach((item) => {
                const dateStr = format(new Date(item.Date), "yyyy-MM-dd");
                if (!grouped[item.RoomTypeCode]) grouped[item.RoomTypeCode] = {};
                grouped[item.RoomTypeCode][dateStr] = item.Count;
            });

            setRoomData(grouped);
        } catch (err) {
            console.error("Error fetching inventory:", err);
        } finally {
            setLoading(false);
        }
    }, [selectedDates]);

    useEffect(() => {
        fetchInventory();
    }, [fetchInventory]);


    //  Init flatpickr
    useEffect(() => {
        flatpickr(inputRef.current, {
            mode: "range",
            dateFormat: "d M Y",
            defaultDate: [selectedDates[0], selectedDates[selectedDates.length - 1]],
            onChange: function (selectedDatesArray) {
                if (selectedDatesArray.length === 2) {
                    const start = selectedDatesArray[0];
                    const end = selectedDatesArray[1];
                    const daysDiff = differenceInDays(end, start);
                    const daysArray = [];
                    for (let i = 0; i <= daysDiff; i++) {
                        daysArray.push(addDays(start, i));
                    }
                    setSelectedDates(daysArray);
                }
            },
        });
    }, []);


    // const [open, setOpen] = useState(false);
    // const [selectionRange, setSelectionRange] = useState({
    //     startDate: new Date(),
    //     endDate: new Date(),
    //     key: "selection",
    // });

    // const handleSelect = (ranges) => {
    //     setSelectionRange(ranges.selection);
    // };



    useEffect(() => {
        const fetchBookings = async () => {
            setLoading(true);
            try {
                const data = await Propertybookings();
                if (Array.isArray(data)) {
                    const today = new Date();
                    const day = today.getDate().toString().padStart(2, "0"); // 04
                    const month = today.toLocaleString("default", { month: "short" }); // Sep
                    const year = today.getFullYear().toString().slice(-2); // 25

                    const todayStr = `${day} ${month} ${year}`; // "04 Sep 25"

                    // Filter bookings with today's CheckInDate
                    const todayBookings = data.filter(
                        (item) => item.CheckInDate === todayStr
                    );

                    setBookingData(todayBookings);
                } else {
                    setBookingData([]);
                }
            } catch (error) {
                console.log("Error fetching bookings", error);
            } finally {
                setLoading(false);
            }
        };
        fetchBookings();
    }, [])

    //   generate pdf


    // const handleGeneratePDF = async (item) => {
    //     setLoading(true);
    //     try {

    //         const voucherData = await Propertybookingpdf(item.BONRESID);
    //         console.log("data", voucherData);
    //         if (!voucherData) {
    //             alert("Unable to fetch voucher details");
    //             return;
    //         }

    //         const voucherHTML = ReactDOMServer.renderToString(
    //             <PropertyBookingVoucher data={voucherData} />
    //         );

    //         const opt = {
    //             margin: 0,
    //             filename: `BookingVoucher_${item.BONRESID}.pdf`,
    //             image: { type: "jpeg", quality: 0.98 },
    //             html2canvas: { scale: 2 },
    //             jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
    //         };

    //         html2pdf().set(opt).from(voucherHTML).save();
    //     } catch (error) {
    //         console.error("Error generating voucher PDF:", error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleGenerateVoucher = async (bonResId) => {
        try {
            setLoading(true);

            // Call API
            const data = await PropertyDynamicVoucher(bonResId);
            const url = data?.url;

            if (!url) {
                alert("Voucher URL not found");
                return;
            }

            console.log("url", url)
            // Download via Blob
            const response = await axios.get(url, {
                responseType: "blob",
            });

            const blob = new Blob([response.data], { type: "application/pdf" });
            const blobUrl = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = `Voucher_${bonResId}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(blobUrl);

        } catch (error) {
            console.error("Voucher download failed:", error);
            alert("Failed to download voucher");
        } finally {
            setLoading(false);
        }
    };
// check
    // Booking Cancel reason Function
    useEffect(() => {
        const fetchCancelReason = async () => {
            try {
                const result = await PropertyCancelReason();
                console.log("reason data", result);
                setCancelCodes(result || []);
            }
            catch (error) {
                console.log("error fetching cancel resons in Booking list page", error);
            }
        }
        fetchCancelReason();
    }, []);

    const handleCodeChange = (e) => {
        const code = e.target.value;
        setSelectedCode(code);

        const selected = cancelCodes.find((c) => c.Code === code);
        if (selected) {
            setCancelReason(selected.Description);
        } else {
            setCancelReason("");
        }
    };

    // reset form
    const resetCancelForm = () => {
        setSelectedCode("");
        setCancelReason("");
        setSelectedBooking(null);
    };

    //   cancel booking
    const handleCancelBooking = async (item) => {

        if (!selectedCode) {
            alert("Please select a cancellation code.");
            return;
        }

        if (!cancelReason) {
            alert("Please enter a reason.");
            return;
        }

        setLoading(true);
        try {
            const result = await PropertyBookingCancle(item.BONRESID, item.PropertyID, selectedCode, cancelReason);

            if (result && result.BONRESID) {
                swal("Booking cancelled successfully!", {
                    icon: "success",
                    buttons: {
                        confirm: {
                            text: "OK",
                            className: "btn btn-success",
                        },
                    },
                }).then(() => {

                    const modal = window.bootstrap.Modal.getInstance(
                        document.getElementById("Cancel-Booking-Resion")
                    );
                    if (modal) modal.hide();

                    resetCancelForm(); // reset fields
                });

                // Table update: remove cancelled booking ya fetch list again
                setBookingData((prev) =>
                    prev.map((b) =>
                        b.BONRESID === item.BONRESID ? { ...b, BookingStatus: "Cancelled" } : b
                    )
                );

            } else {
                alert(result?.message || "Failed to cancel booking");
            }
        } catch (error) {
            console.error(error);
            alert("Error cancelling booking");
        } finally {
            setLoading(false);
        }

    };

    // const data = [
    //     { date: "02 Jan", confirmed: 480, pending: 20 },
    //     { date: "03 Jan", confirmed: 520, pending: 32 },
    //     { date: "04 Jan", confirmed: 470, pending: 28 },
    //     { date: "05 Jan", confirmed: 650, pending: 22 },
    //     { date: "06 Jan", confirmed: 700, pending: 38 },
    //     { date: "07 Jan", confirmed: 300, pending: 20 },
    //     { date: "08 Jan", confirmed: 410, pending: 35 },
    //     { date: "09 Jan", confirmed: 720, pending: 25 },
    //     { date: "10 Jan", confirmed: 390, pending: 24 },
    //     { date: "11 Jan", confirmed: 310, pending: 15 },
    //     { date: "12 Jan", confirmed: 240, pending: 18 },
    // ];

    useEffect(() => {
        const $ = window.$;
        if (bookingData.length > 0 && $ && $.fn.dataTable) {
            const table = $('.basic-datatables').DataTable();
            if (table) {
                table.destroy();
            }
            setTimeout(() => {
                $('.basic-datatables').DataTable();
            }, 0);
        }
    }, [bookingData]);

    return (
        <>
            <style>{`
        

.availability-table-wrapper {
    overflow-x: auto;
}


.availability-table {
    min-width: max-content; 
    border-collapse: collapse;
    width: 100%;
}

.availability-table th,
.availability-table td {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #dee2e6;
}


.availability-table th:first-child,
.availability-table td:first-child {
    position: sticky;
    left: 0;
    background: #fff; 
    z-index: 2;
    text-align: left;
    font-weight: bold;
}


.availability-table thead th:first-child {
    z-index: 3;
}


.availability-table th:not(:first-child),
.availability-table td:not(:first-child) {
    min-width: 100px; /* adjust width as needed */
    max-width: 100px;
}


.availability-table .badge.bg-danger {
    font-size: 0.85rem;
    padding: 0.35em 0.6em;
}


.btn-primary {
    background-color: #a3afff !important;
    border-color: #a3afff !important;
}

// .card-body {
//     overflow-x: auto !important;
//     overflow-y: visible !important; 
// }


// .table td .dropdown-menu {
//     position: absolute !important;
//     z-index: 1050 !important; 
// }


             `}</style>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}

            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />
                    <div className="container">
                        <div className="page-inner">

                            <div className="page-header">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h3 className="page-title">Dashboard</h3>

                                    </div>
                                </div>
                            </div>




                            {/* <div className="row">
                                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                                    <div className="dash-card">
                                        <div className="dash-icon">
                                            <i className="fas fa-hotel"></i>
                                        </div>
                                        <div className="dash-info">
                                            <h3>45</h3>
                                            <span>Total Booking</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                                    <div className="dash-card">
                                        <div className="dash-icon">
                                            <i className="fas fa-sort-amount-up"></i>
                                        </div>
                                        <div className="dash-info">
                                            <h3>65,461</h3>
                                            <span>Total Amount</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                                    <div className="dash-card">
                                        <div className="dash-icon">
                                            <i className="fas fa-user"></i>
                                        </div>
                                        <div className="dash-info">
                                            <h3>167</h3>
                                            <span>Total Customer</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                                    <div className="dash-card">
                                        <div className="dash-icon">
                                            <i className="fas fa-money-check-alt"></i>
                                        </div>
                                        <div className="dash-info">
                                            <h3>70,881</h3>
                                            <span>Total Revenue</span>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            {/* table  */}
                            <div className="card">
                                <div className="card-header d-flex justify-content-between align-items-center mb-0">

                                    <h5 className="card-title ">Total Available Room's</h5>
                                    {/* <!-- Check in & check out --> */}
                                    <div className="d-flex">
                                        <i class="fas fa-calendar fs-3 me-2 mt-2"></i>
                                        <div class="form-control-border form-control-transparent form-fs-md">
                                            <input type="text" class="form-control flatpickr" data-mode="range" placeholder="Select date" ref={inputRef} style={{ width: "17rem", marginTop: "-2px" }} />
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body availability-table-wrapper" >
                                    <table className="table table-bordered availability-table ">
                                        <thead>
                                            <tr>
                                                <th className="text-start" style={{ width: "357px" }}>Room Type</th>

                                                {selectedDates.map((d, i) => (
                                                    <th key={i}>{format(d, "MMM d")}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.keys(roomData).map((roomType, idx) => (
                                                <tr key={idx}>
                                                    <td className="fw-bold text-start">{roomType}</td>
                                                    {selectedDates.map((d, i) => {
                                                        const dateStr = format(d, "yyyy-MM-dd");
                                                        const count = roomData[roomType][dateStr] || 0;
                                                        return (
                                                            <td key={i}>
                                                                {count === 0 ? (
                                                                    <span className="badge bg-danger">0</span>
                                                                ) : (
                                                                    count
                                                                )}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>
                            </div>



                            {/* <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        <h3 className="card-title">Reservation</h3>
                                        <div style={{ width: "105%", height: 290 }}>
                                            <ResponsiveContainer>
                                                <BarChart data={data}>
                                                    <CartesianGrid strokeDasharray="3 3" />
                                                    <XAxis dataKey="date" />

                                                    
                                                    <YAxis yAxisId="left" label={{ value: 'Booking Confirmed', angle: -90, position: 'insideLeft' }} />

                                                    
                                                    <YAxis yAxisId="right" orientation="right" label={{ value: 'Booking Pending', angle: 90, position: 'insideRight' }} />

                                                    <Tooltip />
                                                    <Legend verticalAlign="top" />

                                                    <Bar yAxisId="left" dataKey="confirmed" fill="#2a2f5b" name="Booking Confirmed" barSize={30} />
                                                    <Line yAxisId="right" dataKey="pending" stroke="#f0ad4e" name="Booking Pending" strokeWidth={3} />
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </div>
                                    </div>
                                </div>
                            </div> */}


                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">Today Booking List</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table
                                                    // id="basic-datatables"
                                                    className="display table  table-bordered table-striped table-hover basic-datatables"
                                                // style={{ width: '100%', tableLayout: 'auto' }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "45px" }}>Sr#</th>
                                                            <th style={{ width: "110px" }} >BON REF. Id</th>
                                                            <th style={{ width: "110px" }}>PMS ID</th>
                                                            <th style={{ width: "95px" }}>Check-in</th>
                                                            <th style={{ width: "110px" }}>Check-out</th>
                                                            <th >Guest Info</th>
                                                            <th style={{ width: "81px" }}>Payment </th>
                                                            <th style={{ width: "81px" }}>Status</th>
                                                            <th style={{ width: "95px" }}>Book On</th>
                                                            <th>Action </th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {bookingData.length > 0 ? (
                                                            bookingData.map((item) => (
                                                                <tr key={item.ID}>
                                                                    <td>{item.SrNo}</td>
                                                                    <td>{item.BONRESID}</td>
                                                                    <td>{item.PMSRESID}</td>
                                                                    <td>{item.CheckInDate}</td>
                                                                    <td>{item.CheckOutDate}</td>
                                                                    <td>
                                                                        <b>{item.GuestName}</b>
                                                                        <div>{item.CompanyName}</div>
                                                                    </td>
                                                                    <td>
                                                                        <div>₹ {item.TotalPayment}</div>
                                                                        <div>
                                                                            <span
                                                                                className={
                                                                                    item.PaymentStatus === "Paid"
                                                                                        ? "text-success"
                                                                                        : item.PaymentStatus === "Pending"
                                                                                            ? "text-warning"
                                                                                            : "text-secondary"
                                                                                }
                                                                            >
                                                                                {item.PaymentStatus || "N/A"}
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <span
                                                                            className={
                                                                                item.BookingStatus === "Confirmed"
                                                                                    ? "text-success"
                                                                                    : item.BookingStatus === "Pending"
                                                                                        ? "text-warning"
                                                                                        : item.BookingStatus === "Cancelled"
                                                                                            ? "text-danger"
                                                                                            : "text-secondary"
                                                                            }
                                                                        >
                                                                            {item.BookingStatus || "N/A"}
                                                                        </span>
                                                                    </td>
                                                                    <td>{item.BookingDate}</td>
                                                                    <td className="text-center">
                                                                        <div className="dropdown dropdown-action">
                                                                            <a href="/" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false" >
                                                                                <i className="fas fa-ellipsis-v" style={{ color: "#333" }}></i>
                                                                            </a>
                                                                            <div className="dropdown-menu dropdown-menu-right" >
                                                                                {/* <button type='button' className="dropdown-item" onClick={() => handleModifyClick(item)}><i className='fas fa-edit me-1'></i> Modify </button> */}
                                                                                {item.BookingStatus !== "Cancelled" && (
                                                                                    <button type="button" className="dropdown-item" data-bs-toggle="modal"
                                                                                        data-bs-target="#Cancel-Booking-Resion" onClick={() => {
                                                                                            setSelectedBooking(item); setSelectedCode("");
                                                                                            setCancelReason("");
                                                                                        }} ><i className='fas fa-ban me-2'></i>Cancelled</button>
                                                                                )}

                                                                                {/* <button className="dropdown-item" onClick={() => handleGeneratePDF(item)} > <i className="fas fa-sticky-note me-2"></i> Booking Voucher </button> */}
                                                                                <button className="dropdown-item" onClick={() => handleGenerateVoucher(item.BONRESID)}> <i className="fas fa-sticky-note me-2"></i> Booking Voucher </button>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="10" className="text-center">
                                                                    No Bookings For Today
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Cancel Model */}
                            <div
                                className="modal fade"
                                id="Cancel-Booking-Resion"
                                tabIndex={-1}
                                aria-labelledby="exampleModalLabel"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title" id="exampleModalLabel">
                                                Booking Cancel
                                            </h4>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body">

                                            <div class="mb-3">
                                                <label class="col-form-label">Code:</label>
                                                <select class="form-control form-select" value={selectedCode}
                                                    onChange={handleCodeChange}>
                                                    <option>Select Code</option>
                                                    {cancelCodes.map((c) => (
                                                        <option key={c.Code} value={c.Code}>
                                                            {c.Code}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="" className="col-form-label">
                                                    Cancel Reason:
                                                </label>
                                                <textarea className="form-control" value={cancelReason}
                                                    onChange={(e) => setCancelReason(e.target.value)} />
                                            </div>

                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" onClick={() => handleCancelBooking(selectedBooking)} className="btn btn-danger">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div >
        </>
    );
}

